module.exports = __webpack_public_path__ + "img/arrears-amount-total.87477a85.svg";